module.exports = __webpack_public_path__ + "img/Survival.482592fe.png";